export default __webpack_public_path__ + "images/round_arrow.951237.png";